import { render, staticRenderFns } from "./addBorrowType.vue?vue&type=template&id=e5573792"
import script from "./addBorrowType.vue?vue&type=script&lang=js"
export * from "./addBorrowType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports